import Analytic from './Analytic.js';

// eslint
/* global cast, ns_ */

export default class ComScore extends Analytic {
    /**
     * Create ComScore Analytics
     * @param {Object} options
     * @param {Logger} logger
     */
    constructor(options, logger) {
        super(options, logger);
        this.name = 'ComScore';

        const defaultOptions = {
            publisherId: null
        };
        this.options = Object.assign(defaultOptions, this.options);

        this.streamingAnalytics = new ns_.StreamingAnalytics({
            publisherId: this.options.publisherId,
            debug: true
        });

        this.streamingAnalytics.setLabels({
            ns_site: 'test',
            ns_st_mp: '24i-smartott',
            ns_st_mv: 1.0,
            ns_st_it: 'c'
        });
    }

    /**
     * Initialize events
     */
    initEvents() {
        this.logger.info(`Initialize ${this.name} Analytics Events`);
        this.playerManager.addEventListener(
            cast.framework.events.EventType.BITRATE_CHANGED,
            (event) => {
                this.bitrateChangedEvent(event);
            }
        );

        this.playerManager.addEventListener(
            cast.framework.events.EventType.BUFFERING,
            (event) => {
                this.bufferingEvent(event);
            }
        );

        this.playerManager.addEventListener(
            cast.framework.events.EventType.CLIP_ENDED,
            (event) => {
                this.clipEndedEvent(event);
            }
        );

        this.playerManager.addEventListener(
            cast.framework.events.EventType.ERROR,
            (event) => {
                this.errorEvent(event);
            }
        );

        this.playerManager.addEventListener(
            cast.framework.events.EventType.MEDIA_FINISHED,
            (event) => {
                this.mediaFinishedEvent(event);
            }
        );

        this.playerManager.addEventListener(
            cast.framework.events.EventType.MEDIA_STATUS,
            (event) => {
                this.mediaStatusEvent(event);
            }
        );

        this.playerManager.addEventListener(
            cast.framework.events.EventType.SEGMENT_DOWNLOADED,
            (event) => {
                this.segmentDownloadedEvent(event);
            }
        );

        this.playerManager.addEventListener(
            cast.framework.events.EventType.BREAK_STARTED,
            (event) => {
                this.breakEvent(event);
            }
        );

        this.playerManager.addEventListener(
            cast.framework.events.EventType.BREAK_ENDED,
            (event) => {
                this.breakEvent(event);
            }
        );

        this.playerManager.addEventListener(
            cast.framework.events.EventType.BREAK_CLIP_LOADING,
            (event) => {
                this.breakEvent(event);
            }
        );

        this.playerManager.addEventListener(
            cast.framework.events.EventType.BREAK_CLIP_STARTED,
            (event) => {
                this.breakEvent(event);
            }
        );

        this.playerManager.addEventListener(
            cast.framework.events.EventType.BREAK_CLIP_ENDED,
            (event) => {
                this.breakEvent(event);
            }
        );
    }

    setAsset(asset) {
        this.streamingAnalytics.getPlaybackSession().setAsset(asset);
    }

    bitrateChangedEvent(event) {
        // notifyChangeBitrate
        this.logger.info(`${this.name}: BitRate Change Event`);
        this.logger.debug('event', event);
        this.streamingAnalytics.notifyChangeBitrate(event.totalBitrate);
    }

    bufferingEvent(event) {
        // notifyBufferStart
        if (event.isBuffering) {
            this.logger.info(`${this.name}: Buffering Start Event`);
            this.streamingAnalytics.notifyBufferStart();
        } else {
            this.logger.info(`${this.name}: Buffering Stop Event`);
            this.streamingAnalytics.notifyBufferStop();
        }
        this.logger.debug('event', event);
    }

    clipEndedEvent(event) {
        this.logger.info(`${this.name}: Clip Ended Event`);
        this.logger.debug('event', event);
    }

    errorEvent(event) {
        // notifyError
        this.logger.info(`${this.name}: Error Event`);
        this.logger.debug('event', event);

        this.streamingAnalytics.getPlaybackSession().getAsset().setLabel('ns_st_er', event.error);
        this.streamingAnalytics.notifyError();
    }

    mediaFinishedEvent(event) {
        // notifyEnd
        this.logger.info(`${this.name}: Media Finished Event`);
        this.logger.debug('event', event);

        this.streamingAnalytics.notifyEnd(event.currentMediaTime);
    }

    mediaStatusEvent(event) {
        this.logger.info(`${this.name}: Media Status Event`);
        this.logger.debug('event', event);
        if (event.mediaStatus.playerState === 'PLAYING') {
            this.streamingAnalytics.notifyPlay(event.mediaStatus.currentTime);
        } else if (event.mediaStatus.playerState === 'PAUSED') {
            this.streamingAnalytics.notifyPause(event.mediaStatus.currentTime);
        }
    }

    segmentDownloadedEvent(event) {
        this.logger.info(`${this.name}: Segment Downloaded Event`);
        this.logger.debug('event', event);

        this.streamingAnalytics.notifyCustomEvent({
            ns_st_ev: 'segment_downloaded',
            download_time: event.downloadTime,
            size: event.size
        });
    }

    breakEvent(event) {
        this.logger.info(`${this.name}: Break Event`);
        this.logger.debug('event', event);
    }
}
